import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { IAPIUser, Role } from '../../interfaces/user';
import { UsersService } from '../../../services/users.service';
import { CompanyService } from '../../../companies/company.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {
  userPicture = '../../../assets/img/user-img.webp';
  user?: IAPIUser | null;
  selectedValue?: string | null;
  @Output() optionSelected = new EventEmitter<void>();
  protected readonly Role = Role;

  constructor(
    public router: Router,
    private auth: Auth,
    private usersService: UsersService,
    protected companyService: CompanyService,
  ) {
    this.selectedValue = this.companyService.selectedCompany();
  }

  selectCompany(event?: string) {
    this.companyService.selectCompany(event)
  }

  ngOnInit(): void {
    authState(this.auth).subscribe(async (authState) => {
      this.user = await this.usersService.me();
      this.userPicture = authState?.photoURL ?? '../../../assets/img/user-img.webp';
    });
  }

  async navigate(page: string) {
    await this.router.navigate([`/${page}`]);
    this.toggleSideBar();
  }

  logOut() {
    void this.auth.signOut();
    void this.router.navigate(['/login']);
  }

  toggleSideBar() {
    if (window.innerWidth < 768) this.optionSelected.emit();
  }
}
